<template>
    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <button
            class="o-button -icon-reverse -stroke -button-text"
            @click="searchByVin=true"
            v-if="!searchByVin"
        >
            <span class="o-button__text">
                <span class="o-button__text__elm">{{ _t('Rechercher marque, modèle et année par NIV') }}</span>
            </span>
            <span class="o-button__ico">
            
                    <svgIco icon="search" class="o-ico icon-arrow-left-full" />
            </span>
        </button>

        <inputlabel :field="field" v-if="searchByVin && field.inputLabel != ''" />
        <div class="o-form__item o-input-vindecode-finder" :class="{'-loading': loading, 'is-form-invalid': !isValid}" v-if="searchByVin">
            <input
                class="o-input"
                :class="{ 'readonly': field.inputReadonly === true }"
                v-on="readOnlyHandlers"
                type="text"
                v-model="field.value"
                :id="'input-'+field.id"
                :name="field.inputName"
                :placeholder="field.inputPlaceholder"
                :required="(field.inputRequired === true) ? 'required' : false"
                @input="vinDecode"
                maxlength="17"
                ref="vindecodeInput"
            >
            <div class="o-form__validation">
                <span class="o-form__validation__required">
                </span>
                <span class="o-form__validation__required">
                    {{ _t('Ce champ est obligatoire.') }}
                </span>
                <span class="o-form__validation__error" v-if="errorMsg==''">
                    {{ _t('Ce champ est invalide.') }} {{ _t('Il doit être composé de 17 caractères et ne doit pas contenir de o, i ou q.') }}
                </span>
                <span class="o-form__validation__error" v-else v-html="errorMsg">
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Input-vindecode',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
        	return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                },
                searchByVin: true,
                loading: false,
                isValid: true,
                errorMsg: "",
        	}
        },
        mounted(){
            this.$root.getSessionInfo()
        },
        methods: {

            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            },

            validateVin: function() {
                this.isValid = true;
                this.errorMsg = "";

                this.$refs.vindecodeInput.setCustomValidity('')
                let makeChoice = this.field.inputVindecodeMapping.find((item) => {
                    return item.text.toLowerCase() === 'make';
                });
                if (makeChoice) {
                    this.emitter.emit('set-form-value', {
                        fieldName: makeChoice.value,
                        fieldValue: null
                    });
                }
                let modelChoice = this.field.inputVindecodeMapping.find((item) => {
                    return item.text.toLowerCase() === 'model';
                });
                if (modelChoice) {
                    this.emitter.emit('set-form-value', {
                        fieldName: modelChoice.value,
                        fieldValue: null
                    });
                }
                let yeearChoice = this.field.inputVindecodeMapping.find((item) => {
                    return item.text.toLowerCase() === 'year';
                });
                if (yeearChoice) {
                    this.emitter.emit('set-form-value', {
                        fieldName: yeearChoice.value,
                        fieldValue: null
                    });
                }



                if(!this.field.value) return this.isValid;
                if(this.field.value.toLowerCase().includes('o')) this.isValid = false;
                if(this.field.value.toLowerCase().includes('i')) this.isValid = false;
                if(this.field.value.toLowerCase().includes('q')) this.isValid = false;
                if(this.field.value.length != 17 && this.field.value.length > 0) this.isValid = false;

                if (!this.isValid) this.$refs.vindecodeInput.setCustomValidity('invalid')

                return this.isValid;
            },

            vinDecode: function() {
                this.loading = false
                
                if(!this.validateVin()) return;
                if (!this.field.value || this.field.value.trim().length == 0) return;

                this.loading = true
                if(!this.$root.session){
                    this.$root.getSessionInfo().then((session) => {
                        this.vinDecode();
                    });
                    return
                }
                
                this.loading = true
                const formData = new FormData();
                // formData.append('useCache', false);
                formData.append('currentlanguage', this.$root.currentlanguage);

                fetch('/flexibleform/vindecoder/'+this.field.value, {
                    method: "POST", // *GET, POST, PUT, DELETE, etc.
                    headers: {
                        'Accept': 'application/json',
                        'X-CSRF-Token': this.$root.session.csrfTokenValue,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    let makeChoice = this.field.inputVindecodeMapping.find((item) => {
                        return item.text.toLowerCase() === 'make';
                    });
                    if(makeChoice && data.data?.MarketingMakes?.MarketingMake?.Description){
                        this.emitter.emit('set-form-value', {
                            fieldName: makeChoice.value,
                            fieldValue: data.data.MarketingMakes.MarketingMake.Description
                        });
                    }
                    let modelChoice = this.field.inputVindecodeMapping.find((item) => {
                        return item.text.toLowerCase() === 'model';
                    });
                    if (modelChoice && (data.data?.MarketingMakes?.MarketingMake?.Models?.Model?.Description || data.data?.MarketingMakes?.MarketingMake?.Models?.Model[0]?.Description)){
                        this.emitter.emit('set-form-value', {
                            fieldName: modelChoice.value,
                            fieldValue: (data.data.MarketingMakes.MarketingMake.Models.Model.Description) ? data.data.MarketingMakes.MarketingMake.Models.Model.Description : data.data.MarketingMakes.MarketingMake.Models.Model[0].Description
                        });
                    }
                    let yeearChoice = this.field.inputVindecodeMapping.find((item) => {
                        return item.text.toLowerCase() === 'year';
                    });
                    if(yeearChoice && data.data?.YearValue){
                        this.emitter.emit('set-form-value', {
                            fieldName: yeearChoice.value,
                            fieldValue: data.data.YearValue
                        });
                    }

                    if (data.data.DecodeErrors?.DecodeError?.Message){
                        this.errorMsg = data.data.DecodeErrors.DecodeError.Message;
                        this.$refs.vindecodeInput.setCustomValidity('invalid')
                        this.isValid = false;
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    this.errorMsg = error
                })
                .finally(() => {
                    this.loading = false;
                });


            }
        },
    }
</script>